import { PublicClientApplication } from '@azure/msal-browser'; 
import { reactive } from 'vue';

const clientIdKey = window.env?.MSAL_CLIENT_ID;
const authorityKey = window.env?.MSAL_AUTHORITY;

if (!clientIdKey || !authorityKey) {
  throw new Error('window.env.MSAL_CLIENT_ID and window.env.MSAL_AUTHORITY must be defined in config.js');
}

// Get the current origin (handles both localhost and production)
const currentOrigin = window.location.origin;

export const msalConfig = {
  auth: {
    clientId: clientIdKey,
    authority: authorityKey,
    redirectUri: currentOrigin + "/",
    postLogoutRedirectUri: currentOrigin + "/",
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage', 
    storeAuthStateInCookie: false   
  },
  system: {
    allowNativeBroker: false,     
    tokenRenewalOffsetSeconds: 300  
  }
};

export const state = reactive({
  isAuthenticated: false,
  user: null, 
});

export const msalInstance = new PublicClientApplication(msalConfig);